import React, { useState, useCallback } from 'react';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import Box from '@material-ui/core/Box';

import { useStyles } from './styles';

interface SingleGiftCardProps {
  cardImageSrc: string;
  name: string;
  amount: number;
  currencyCode: string;
}

export const SingleGiftCard: React.FC<SingleGiftCardProps> = ({ cardImageSrc, name, amount, currencyCode }) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const classes = useStyles({ isImageLoaded });

  const handleImageLoad = useCallback(() => {
    setIsImageLoaded(true);
  }, []);

  return (
    <>
      <Box display="flex" paddingRight={12}>
        <img src={cardImageSrc} alt={'gift card'} onLoad={handleImageLoad} className={classes.cardImage} />
        {!isImageLoaded && <Skeleton variant="rect" width={152} height={93} />}
      </Box>
      <Box flex={1} display="flex" justifyContent="space-between">
        <Typography className={classes.cardText}>{name}</Typography>
        <Typography className={classes.cardText}>{`${amount} ${currencyCode}`}</Typography>
      </Box>
    </>
  );
};
